import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state () {
    return {
      // 就是公共的数据，所有的组件都可以直接使用
      selectedProductAry: [], // 选择产品使用
    }
  }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js